
import { Injectable } from '@angular/core';
import { Observable, Subject, forkJoin } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';

import { SFDataEndpoint } from './sf-data-endpoint.service';
import { AuthService } from './auth.service';
import { IDPReport, MasterConfig, CPReport, CMReport, CDReport, ICD, ResponseAPI, ICDStep2, ICDStep3, EmailLog } from '../models/IDPReport.model';
import { SFLogin } from '../models/user.model';


@Injectable({
  providedIn: 'root'
})
export class SfDataService {

  constructor(private authService: AuthService,
    private sFDataEndpoint: SFDataEndpoint) { }

  getIDPReports(page?: number, pageSize?: number) {
    
    return this.sFDataEndpoint.getIDPReportEndpoint<IDPReport[]>(page, pageSize);
  }

  getEmails(page?: number, pageSize?: number) {

    return this.sFDataEndpoint.getEmails<EmailLog[]>(page, pageSize);
  }
  getCPReports(page?: number, pageSize?: number) {

    return this.sFDataEndpoint.getCPReportEndpoint<CPReport[]>(page, pageSize);
  }

  getCMReports(page?: number, pageSize?: number) {

    return this.sFDataEndpoint.getCMReportEndpoint<CMReport[]>(page, pageSize);
  }

  getCampaignContacts() {

    return this.sFDataEndpoint.getCampaignContactsEndpoint<any[]>();
  }

  getRetails(page?: number, pageSize?: number) {

    return this.sFDataEndpoint.getRetailsEndpoint<any>(page, pageSize);
  }

  getAddInfoDDs(page?: number, pageSize?: number) {

    return this.sFDataEndpoint.getAddInfoDDsEndpoint<any>(page, pageSize);
  }

  GetAccountHubs(page?: number, pageSize?: number) {

    return this.sFDataEndpoint.GetAccountHubs<any>(page, pageSize);
  }

  // Feature 9 — Hub LT-Report CSV upload
  uploadHubReport(body: any) {
    return this.sFDataEndpoint.uploadHubReportEndpoint<any>(body);
  }

  getHubReportMissing(weekEnding?: string) {
    return this.sFDataEndpoint.getHubReportMissingEndpoint<any>(weekEnding);
  }

  getHubReportContext() {
    return this.sFDataEndpoint.getHubReportContextEndpoint<any>();
  }

  GetAccountReps(str?: string,str1?:string) {
    
    return this.sFDataEndpoint.GetAccountReps<any>(str,str1);
  }

  CheckDueDeligRequired(str?: string, str1?: string, str2? : string) {

    return this.sFDataEndpoint.CheckDueDeligRequired<any>(str, str1, str2);
  }

  ReSendEmail (str?: string) {

    return this.sFDataEndpoint.ReSendEmail<any>(str);
  }

  resendEmailLog(emailId: string) {
    return this.sFDataEndpoint.ResendEmailLog<any>(emailId);
  }

  CheckDueDeligRequiredMyOwnOffice(str?: string, str1?: string, str2?: string) {

    return this.sFDataEndpoint.CheckDueDeligRequiredMyOwnOffice<any>(str, str1, str2);
  }
  GetCaseData(str?: string, str1?: string) {

    return this.sFDataEndpoint.GetCaseData<any>(str,str1);
  }

  getCDReports(page?: number, pageSize?: number) {

    return this.sFDataEndpoint.getCDReportEndpoint<CDReport[]>(page, pageSize);
  }
   
  checkTaxIdExists(taxId: string) {
    return this.sFDataEndpoint.checkTaxIdExists<{ exists: boolean }>(taxId);
  }

  CreateICD(user: ICD) {
    return this.sFDataEndpoint.CreateICD<ResponseAPI>(user);
  }

  CreateICDStep2(user: ICDStep2) {
    return this.sFDataEndpoint.CreateICDStep2<ResponseAPI>(user);
  }

  CreateICDStep3(user: ICDStep3) {
    return this.sFDataEndpoint.CreateICDStep3<ResponseAPI>(user);
  }

  CreateAddLoc(user: ICDStep3) {
    return this.sFDataEndpoint.CreateAddLoc<ResponseAPI>(user);
  }

  stageAttachment(body: any): Observable<any> {
    return this.sFDataEndpoint.stageAttachmentEndpoint<any>(body);
  }

  // Step 2 (icdinfo) anonymous upload — routes to the [AllowAnonymous] SFStep2 endpoint.
  stageAttachmentStep2(body: any): Observable<any> {
    return this.sFDataEndpoint.stageAttachmentStep2Endpoint<any>(body);
  }

  CreateOffBoard(user: ICDStep3) {
    return this.sFDataEndpoint.CreateOffBoard<ResponseAPI>(user);
  }

  CreateCampChange(user: ICDStep3) {
    return this.sFDataEndpoint.CreateCampChange<ResponseAPI>(user);
  }

  CreateICDClose(user: ICDStep3) {
    return this.sFDataEndpoint.CreateICDClose<ResponseAPI>(user);
  }

  ChangeOfficeInfo(user: ICDStep3) {
    return this.sFDataEndpoint.ChangeOfficeInfo<ResponseAPI>(user);
  }
  HubMaintain(user: ICDStep3) {
    return this.sFDataEndpoint.HubMaintain<ResponseAPI>(user);
  }
  CreateMoveLoc(user: ICDStep3) {
    return this.sFDataEndpoint.CreateMoveLoc<ResponseAPI>(user);
  }

  CreateInactiveOff(user: ICDStep3) {
    return this.sFDataEndpoint.CreateInactiveOff<ResponseAPI>(user);
  }

  CreateReOpen(user: ICDStep3) {
    return this.sFDataEndpoint.CreateReOpen<ResponseAPI>(user);
  }


  CreateICDStep4(user: ICDStep3) {
    return this.sFDataEndpoint.CreateICDStep4<ResponseAPI>(user);
  }


  LoginSF(user: SFLogin) {
    return this.sFDataEndpoint.LoginSF<ResponseAPI>(user);
  }


  getMasterConfigs(str? : string) {
    return this.sFDataEndpoint.getMasterConfigs<MasterConfig[]>(str);
  }


  getICD(str?: string) {
    return this.sFDataEndpoint.getICD<ICD>(str);
  }

  getOTP(str?: string,str1?: string,str2?:string) {
    return this.sFDataEndpoint.getOTP<any>(str,str1,str2);
  }

  getICDStep3(str?: string) {
    return this.sFDataEndpoint.getICDStep3<ICD>(str);
  }


  getICDStep3byAcc(str?: string) {
    return this.sFDataEndpoint.getICDStep3byAcc<ICD>(str);
  }


  getICDStep3byAccJDE(str?: string, dcode?: string) {
    return this.sFDataEndpoint.getICDStep3byAccJDE<ICD>(str,dcode);
  }

  
  getICDLocationsByAccount(str?: string) {
    return this.sFDataEndpoint.getICDLocationsByAccount<ICD>(str);
  }

  getUsers() {
    return this.sFDataEndpoint.GetUsers<any>();
  }

  sendComposedEmail(emailData: any) {
    return this.sFDataEndpoint.SendComposedEmail<ResponseAPI>(emailData);
  }

  verifyDocument(body: any): Observable<any> {
    console.log('[DocVerify] ▶ sending request', {
      documentType: body.documentType,
      mimeType: body.mimeType,
      companyName: body.companyName,
      base64Length: body.base64Content?.length ?? 0,
    });
    return this.sFDataEndpoint.verifyDocumentEndpoint<any>(body).pipe(
      tap({
        next: (result) => {
          console.log('[DocVerify] ✔ response', result);
          if (result?.diagnosticInfo) {
            console.error('[DocVerify] ✖ backend exception:', result.diagnosticInfo);
          }
        },
        error: (err) => console.error('[DocVerify] ✖ network/HTTP error', err),
      })
    );
  }

  getDashboardStats() {
    return this.sFDataEndpoint.getDashboardStatsEndpoint<any>();
  }

  getAddressChangeTasks() {
    return this.sFDataEndpoint.getAddressChangeTasksEndpoint<any>();
  }

  getHelpfulContacts() {
    return this.sFDataEndpoint.getHelpfulContactsEndpoint<any[]>();
  }

  createHelpfulContact(contact: any) {
    return this.sFDataEndpoint.createHelpfulContactEndpoint<any>(contact);
  }

  updateHelpfulContact(id: number, contact: any) {
    return this.sFDataEndpoint.updateHelpfulContactEndpoint<any>(id, contact);
  }

  deleteHelpfulContact(id: number) {
    return this.sFDataEndpoint.deleteHelpfulContactEndpoint<any>(id);
  }

}
